var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('My-Nav'),_c('my-sec-nav'),_c('router-view'),_c('my-download'),_c('my-foot')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }